import { render, staticRenderFns } from "./AccessoryLegalNotices.vue?vue&type=template&id=620373b4&"
import script from "./AccessoryLegalNotices.vue?vue&type=script&lang=js&"
export * from "./AccessoryLegalNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620373b4')) {
      api.createRecord('620373b4', component.options)
    } else {
      api.reload('620373b4', component.options)
    }
    module.hot.accept("./AccessoryLegalNotices.vue?vue&type=template&id=620373b4&", function () {
      api.rerender('620373b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/AccessoryLegalNotices.vue"
export default component.exports